import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";

import useAuthModalContext from "../../../hooks/useAuthModalContext";
import { AuthModalForm } from "../../atoms/AuthModalForm";
import AuthenticationModal from "../AuthenticationModal";

interface IAuthModalContainerProps {
  showLoginModal: boolean;
}

const AuthModalContainer = ({ showLoginModal }: IAuthModalContainerProps) => {
  const {
    shouldShowArrowNavigation,

    handleBackAuthModal,
    handleCloseAuthModal,
    RenderPage,
  } = useAuthModalContext();

  return (
    <AuthenticationModal
      shouldShowArrowNavigation={shouldShowArrowNavigation}
      showLoginModal={showLoginModal}
      onReturnModalStep={handleBackAuthModal}
      onCloseAuthModal={handleCloseAuthModal}
    >
      <ComponentErrorBoundary>
        <AuthModalForm.Logo />
      </ComponentErrorBoundary>

      <RenderPage />
    </AuthenticationModal>
  );
};

export default AuthModalContainer;
